module.exports = __webpack_public_path__ + "img/PL10048.1df1e104.png";